import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { GetCondutorModel } from '@app/data/condutor/models';
import { CondutorRepository } from '@data/condutor/condutor.repository';

@Injectable()
export class CondutorController extends BaseController<GetCondutorModel> {
  constructor(condutorRepository: CondutorRepository) {
    super(condutorRepository);
  }
}
